import {Component, Input} from '@angular/core';
import {AlertSettings} from '../../hickory-api/index';

@Component({
  selector: 'app-alert-detail-icons',
  templateUrl: './alert-detail-icons.component.html',
  styleUrls: ['./alert-detail-icons.component.scss'],
  standalone: false
})
export class AlertDetailIconsComponent {
  @Input() alert: AlertSettings = null;
}
